import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { Heartbeat } from "@phosphor-icons/react";

import EmptyWeekImage from "assets/empty_week.png";
import ModuleHeader from "../ModuleHeader";

const ModuleContainer = {
  padding: 10,
  borderRadius: "12px",
  flex: "1 2",
};

/**
 * @description `EmptySummary` component displays an empty summary when there are no scheduled hours.
 * @param {Object} props - The component props.
 * @param {?string} props.clinicianName - The clinician name.
 * @returns {React.ReactNode} The EmptySummary component.
 */
const EmptySummary = ({ clinicianName }) => {
  let summaryText = "Your weekly summary will update as you begin scheduling appointments.";

  if (clinicianName) {
    summaryText = `${clinicianName}'s weekly summary will update as they begin scheduling appointments.`;
  }

  return (
    <Paper component="section" elevation={2} sx={ModuleContainer}>
      <ModuleHeader Icon={Heartbeat} title="Summary this week" />
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={7}
        mt={7}
        alignItems="center"
        data-testid="empty-summary"
      >
        <Box>
          <img src={EmptyWeekImage} width={226} alt="Empty week" />
        </Box>
        <Box>
          <Typography component="p" variant="body1" color="text.secondary">
            {summaryText}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

export default EmptySummary;
